import { render, staticRenderFns } from "./SubjectRegistrationDetailsSBPPS.vue?vue&type=template&id=c7137ce2&scoped=true&"
import script from "./SubjectRegistrationDetailsSBPPS.vue?vue&type=script&lang=js&"
export * from "./SubjectRegistrationDetailsSBPPS.vue?vue&type=script&lang=js&"
import style0 from "./SubjectRegistrationDetailsSBPPS.vue?vue&type=style&index=0&id=c7137ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7137ce2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCheckbox,VCol,VForm,VIcon,VOverlay,VProgressCircular,VRow,VSelect,VSnackbar,VToolbar,VToolbarTitle})
